<template>
    <v-sheet class="pa-3 mb-4" rounded style="min-height:150px;" elevation="1">
        <v-form>
            <v-text-field label="Phone Number" v-model="app.phone_number_input" fluid hide-details="">
                <template v-slot:append>


                    <!-- START AUDIO/MP3 AND DISCONNECT -->
                    <v-menu offset-y v-if="app.callIsActive()">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon>
                                <v-icon color="red">
                                    mdi-voicemail
                                </v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="app.transfer_call()">
                                <v-list-item-title>Auido 1</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="app.transfer_call()">
                                <v-list-item-title>Audio 2</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>



                    
                    <!-- MUTE / UNMUTE -->
                    <v-tooltip bottom v-if="app.callIsActive()">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-if="!app.call.isMuted()"
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click="app.call.mute(true)"
                            >
                                <v-icon color="green">
                                    mdi-microphone
                                </v-icon>
                            </v-btn>
                            <v-btn
                                v-else
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click="app.call.mute(false)"
                            >
                                <v-icon color="red">
                                    mdi-microphone-off
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Unmute</span>
                    </v-tooltip>


                    <!-- CALL -->
                    <v-tooltip bottom v-if="!app.callIsActive()">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click="app.make_call({to: app.phone_number_input, contact_id: app.current_lead.ID})"
                            >
                                <v-icon color="green">
                                    mdi-phone
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Call</span>
                    </v-tooltip>


                    <!-- CALL TO VOICEMAIL -->
                    <v-tooltip bottom v-if="!app.callIsActive()">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click="app.make_call({to: app.phone_number_input, contact_id: app.current_lead.ID, voicemail:true})"
                            >
                                <v-icon color="green">
                                    mdi-phone-missed
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Call to Voicemail</span>
                    </v-tooltip>


                    <!-- HANGUP -->
                    <v-tooltip bottom v-if="app.callIsActive()">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click="app.hangUp()"
                            >
                            <v-icon color="red">
                                    mdi-phone-off
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Hang Up</span>
                    </v-tooltip>

                    <v-tooltip bottom v-if="app.callIsActive()">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click="app.showCallInfo"
                            >
                            <v-icon color="red">
                                    mdi-account-plus
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Add a Coach</span>
                    </v-tooltip>

                    <v-btn
                        icon
                        @click="app.showCallInfo"
                    >
                        <v-icon color="grey">
                            mdi-cog
                        </v-icon>
                    </v-btn>
                    <!-- SETTINGS -->
                    <!-- <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click="user.show_user_settings = true"
                            >
                            <v-icon color="grey">
                                    mdi-cog
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Settings</span>
                    </v-tooltip> -->



                </template>
            </v-text-field>

            <!-- BM: Phone Number switch buttons -->
            <div v-if="!app.callIsActive() && phone_numbers.length > 1">
                <span v-for="(number) in phone_numbers" :key="number">
                    <v-btn v-if="number != app.phone_number_input" rounded small color="secondary" class="mt-2 mr-2" @click="app.phone_number_input = number">{{app.phoneNumberFormat(number)}}</v-btn>
                    <v-btn v-else rounded small disabled class="mt-2 mr-2">{{app.phoneNumberFormat(number)}}</v-btn>
                </span>
            </div>
            <div style="height:55px;" v-if="app.callIsActive()">
                <div class="mt-2 mb-2">
                    <v-btn x-small fab class="mr-1 mb-1" elevation="1" color="secondary" dark
                        @click="app.sendDigits('1')">1</v-btn>
                    <v-btn x-small fab class="mr-1 mb-1" elevation="1" color="secondary" dark
                        @click="app.sendDigits('2')">2</v-btn>
                    <v-btn x-small fab class="mr-1 mb-1" elevation="1" color="secondary" dark
                        @click="app.sendDigits('3')">3</v-btn>
                    <v-btn x-small fab class="mr-1 mb-1" elevation="1" color="secondary" dark
                        @click="app.sendDigits('4')">4</v-btn>
                    <v-btn x-small fab class="mr-1 mb-1" elevation="1" color="secondary" dark
                        @click="app.sendDigits('5')">5</v-btn>
                    <v-btn x-small fab class="mr-1 mb-1" elevation="1" color="secondary" dark
                        @click="app.sendDigits('6')">6</v-btn>
                    <v-btn x-small fab class="mr-1 mb-1" elevation="1" color="secondary" dark
                        @click="app.sendDigits('7')">7</v-btn>
                    <v-btn x-small fab class="mr-1 mb-1" elevation="1" color="secondary" dark
                        @click="app.sendDigits('8')">8</v-btn>
                    <v-btn x-small fab class="mr-1 mb-1" elevation="1" color="secondary" dark
                        @click="app.sendDigits('9')">9</v-btn>
                    <v-btn x-small fab class="mr-1 mb-1" elevation="1" color="secondary" dark
                        @click="app.sendDigits('0')">0</v-btn>
                    <v-btn x-small fab class="mr-1 mb-1" elevation="1" color="secondary" dark
                        @click="app.sendDigits('*')">
                        <v-icon x-small>mdi-asterisk</v-icon>
                    </v-btn>
                    <v-btn x-small fab class="mr-1 mb-1" elevation="1" color="secondary" dark
                        @click="app.sendDigits('#')">
                        <v-icon x-small>mdi-pound</v-icon>
                    </v-btn>
                </div>
            </div>
        </v-form>
    </v-sheet>
</template>

<script>
// import { Device } from '@twilio/voice-sdk'
import { useUserStore } from '../stores/user'
import { useAppStore } from '../stores/app'
    
export default {
    name: 'Dialer',
    props: ['value'],
    data: () => ({
        loading: false,
        // device: null,
        // in_call: false,
        // call: {
        //     parameters: {
        //         CallSid: null
        //     },
        //     isMuted: false
        // },
        // outbound_call_sid: null,
        // twilioVoiceToken: null,
        phone_number_index: 0,
        // phone_number_input: "",
        app: {
            phone_number_input: ""
        }
    }),
    created() {
        this.user = useUserStore()
        this.app = useAppStore()
    },
    mounted: function() {
        // this.loadCommunications()
        this.app.getTwilioToken()
    },
    computed: {
        // phone_number: function() {
        //     console.log("phone_number value:", this.value)
        //     if(typeof this.value == "object") {
        //         this.app.current_to_phone_number = this.value[this.phone_number_index]
        //         return this.value[this.phone_number_index]
        //     }
        //     return ""
        // },
        phone_numbers: function() {
            return this.value
        },
        // callIsActive: function () {
        //     return this.app.call.parameters.CallSid !== null
        // },
    },
    methods: {
        // handleInput (e) {
        //     // console.log("input", e)
        //     // this.$emit('input', this.content)
        // },
        // callInfo: function () {
        //     console.log("info", this.app.device, this.call, this.call.getOutboundConnectionId(), this.call
        //         .getParameters())
        // },
    },
    watch: {
        'phone_numbers': function(newV, oldV) {
            // sets default phone number when the lead loads
            this.app.phone_number_input = newV[0]
        }
    }
}
</script>
